import Regex from 'constants/regex';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { useSelectCardFormValues } from 'selectors/selectors';

dayjs.extend(isBetween);

const getExpiryDate = (formValues: any) => {
  const [month, year] = formValues.expiryDate.split('/').map(Number);
  const expiryDate = dayjs(new Date(2000 + year, month, 0)); // Last day of the month
  return expiryDate;
};

const getIssueDate = (formValues: any) => {
  const [day, month, year] = formValues.issueDate.split('/').map(Number);
  const issueDate = dayjs(new Date(year, month, day));
  return issueDate;
};

export function isWithinDaysBeforeExpiry(days: number): boolean {
  const formValues = useSelectCardFormValues();
  if (!formValues || !formValues.expiryDate || !Regex.EXPIRY_DATE_CARD_DETAILS.test(formValues.expiryDate)) {
    return false;
  }
  const expiryDate = getExpiryDate(formValues);
  const currentDate = dayjs();
  return currentDate.isBetween(expiryDate.subtract(days, 'day'), expiryDate);
}

export function isExpiryBeyondFiveYears(): boolean {
  const formValues = useSelectCardFormValues();
  if (!formValues || !formValues.expiryDate || !Regex.EXPIRY_DATE_CARD_DETAILS.test(formValues.expiryDate)) {
    return false;
  }
  const expiryDate = getExpiryDate(formValues);
  const issueDate = getIssueDate(formValues);
  const isBeyond5Years = expiryDate.isAfter(issueDate.add(5, 'year'));
  if (isBeyond5Years) {
    return true;
  } else {
    return false;
  }
}
